import { call } from "./calls";

export const EventFlow = {
    message: (body) => call('/message', 'POST', body, undefined, false, '/event/flow'),
    conditional: (body) => call('/conditional', 'POST', body, undefined, false, '/event/flow'),
    task: (body) => call('/user/action/submit', 'POST', body, undefined, false, '/event/flow')
};
